import { DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'app-external-connectional-modal',
  templateUrl: './external-connectional-modal.component.html',
  styleUrl: './external-connectional-modal.component.sass',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExternalConnectionalModalComponent {
  projects: any = [];
  allConnections: any = [];
  @Input() selectedConnections: any[] = [];
  isLoading = signal(true);

  constructor(private dialogRef: DialogRef<ExternalConnectionalModalComponent>, public globals: Globals){}

  ngOnInit(): void {
    this.isLoading.set(true);
    this.allConnections = this.globals.shared_projects.filter(proj => proj.shared_level==='read');
  }

  ngAfterViewInit(): void {
    this.isLoading.set(false);
  }

  close(){
    this.dialogRef.close();
  }
}
